import { render, staticRenderFns } from "./JcomTableApprove.vue?vue&type=template&id=637e2239&scoped=true"
import script from "./JcomTableApprove.vue?vue&type=script&lang=js"
export * from "./JcomTableApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e2239",
  null
  
)

export default component.exports